<template>
  <div class="w-full items-center flex pt-4 pb-2 px-6">
    <div class="pl-4 my-auto flex items-center">
      <div class="custom-width">
        <zt-dropdown
          ref="dropDown"
          :title="labelSortOptions"
          :label="labelSortOptions"
          @change="setSortOption"
          outlined
          class="border rounded"
          v-slot="{ itemSelected }"
          data-vs-dropdown="sort-options"
        >
          <zt-dropdown-item
            v-for="(option, index) of sortOpts"
            :key="index"
            :item="option"
            :item-selected="itemSelected"
          />
        </zt-dropdown>
      </div>
      <div class="pl-3">
        <button
          class="flex items-baseline focus:outline-none"
          @click="setOrderTypeSelected"
          data-vs-button="order-type-selected"
        >
          <zt-icon class="text-zt-primary-200" :name="orderTypeIcon" />
          <span class="pl-2 font-medium text-zt-dark-300">{{
            store.orderType === 'desc' ? $t('message.searchComponent.order.descending') : $t('message.searchComponent.order.ascending')
          }}</span>
        </button>
      </div>
    </div>
    <div class="ml-auto d-flex">
      <template v-if="!downloadSelected">
        <zt-button
          style="color: #4f41a3 !important"
          icon="box-arrow-down"
          @click="$emit('download-selected')"
          outlined
          :loader="loader"
          :loaderTxt="$t('message.searchComponent.searchDownloadText')"
          data-vs-button="download-selected"
          >
          {{ $t('message.searchComponent.downloadSelected') }}
        </zt-button
        >
      </template>
      <template v-else>
        <div class="dropdown" v-if="this.isActionAllowed(this.downloadActionId)">
          <zt-button
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            outlined
            icon="box-arrow-down"
            style="color: rgb(79, 65, 163) !important;"
            :loader="loaderList"
            :loaderTxt="$t('message.documentSearch.searchDownloadText')"
            data-vs-button="search-download-text"
          >
            {{ $t('message.searchComponent.download') }}
          </zt-button>
          <div class="dropdown-menu mt-2">
            <button
              class="dropdown-item"
              v-if="store.eforms.length > 0"
              @click="active = !active"
              data-vs-button="item-active"
            >
              {{$t('message.documentSearch.donwload.eformsData') }}
            </button>
            <button class="dropdown-item" @click="downloadExcel" data-vs-button="download-excel">
              {{$t('message.documentSearch.donwload.searchToExcel') }}
            </button>
            <button class="dropdown-item" @click="downloadExcelObservations" data-vs-button="download-excel-observations">
              {{$t('message.documentSearch.donwload.observations') }}
            </button>
          </div>
        </div>
      </template>
      <template v-if="/*!downloadSelected /*&&*/ this.isActionAllowed(this.isActionBackup)">
        <zt-button
          class="ml-3"
          style="color: #4f41a3 !important"
          icon="box-arrow-down"
          @click="validationMFA()"
          outlined
          :loader="loader"
          data-vs-button="validation-mfa"
          >{{$t('message.mfa.backup.button') }}</zt-button
        >
      </template>
      <template v-if="this.isActionAllowed(this.massiveCancel)">
        <zt-button
          class="ml-3"
          style="color: #4f41a3 !important"
          outlined
          :disabled="downloadSelected"
          loaderTxt="Anulando..."
          @click="getModalMassiveCancel()"
          data-vs-button="massive-cancel"
          >{{$t('message.documentSearch.donwload.undoSelection') }}</zt-button
        >
      </template>
      <zt-modal :z-index="1001" max-width="700px" :active="active" @close="active = false">
        <template #modal-header>
          <div class="p-6">
            <span class="text-zt-xl font-bold"
              >{{$t('message.documentSearch.donwload.popup.eformsData.header') }}</span
            >
          </div>
        </template>
        <div class="">
          <div class="px-6 py-8">
            <p>
              {{$t('message.documentSearch.donwload.popup.eformsData.body_a') }}
            </p>
            <p>
              {{$t('message.documentSearch.donwload.popup.eformsData.body_b') }}
            </p>
          </div>
          <div>
            <div class="flex py-6 font-bold">
              <span class="w-2/3 pl-6" >{{$t('message.documentSearch.donwload.popup.eformsData.column_name') }}</span>
              <span class="w-1/3 text-center pr-6">{{$t('message.documentSearch.donwload.popup.eformsData.column_action') }}</span>
            </div>
            <div class="list--container">
              <div
                v-for="eform in store.eforms"
                :key="eform.id"
                class="list--item flex py-6"
              >
                <p class="w-2/3 pl-6" >{{ eform.name }}</p>
                <div class="relative w-1/3 flex items-center justify-center">
                  <button
                    v-if="!isLoadingActive(eform.id)"
                    @click="downloadMetadata(eform.id)"
                    class="focus:outline-none text-zt-primary-200 text-zt-xl"
                    data-vs-button="download-metadata"
                  >
                    <zt-icon name="box-arrow-down" />
                  </button>
                  <vue-loading
                    v-show="isLoadingActive(eform.id)"
                    :active="isLoadingActive(eform.id)"
                    color="#4f41a3"
                    :is-full-page="false"
                    :width="20"
                    :height="20"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </zt-modal>
      <zt-modal :z-index="1001" max-width="700px" :active="activeModalMassiveCancel" @close="massiveCancelModalClose()">
        <template #modal-header>
          <div class="p-6">
            <span class="text-zt-xl font-bold"
              >{{$t('message.cancelDocuments.heading') }}</span
            >
          </div>
        </template>
        <div class="">
          <div class="flex px-8 py-16">
            <div class="warning-icon mr-10 info-icon flex justify-start items-start">
              <zt-icon name="exclamation-circle-outline" />
            </div>
            <div class="items-center mr-12">
              <h2 class="pb-3 text-zt-xl font-normal">
                {{$t('message.cancelDocuments.title') }}
              </h2>
              <p class="text-zt-lg text-justify">
                {{$t('message.cancelDocuments.content') }}
              </p>
            </div>
          </div>
        </div>
        <template slot="modal-footer">
          <div
            class="
              zt-modal-footer
              flex
              justify-end
              lg:justify-end
              items-center
              p-4
            "
            style="background-color: #eeeeee"
          >
            <button text class="mr-6 text-gray-700" @click="massiveCancelModalClose()" data-vs-button="cancel-modal">
              {{$t('message.cancelDocuments.footer.cancel') }}
            </button>
            <zt-button :loader="isLoaderMassiveCancel" class="ml-1" v-on:click="getMassiveCancel()" data-vs-button="massive-Cancel">
              {{$t('message.cancelDocuments.footer.cancelled') }}
            </zt-button
            >
          </div>
        </template>
      </zt-modal>
      <zt-modal :z-index="1001" max-width="700px" :active="activeModalBackup" @close="backupDownloadClose()">
        <template #modal-header>
          <div class="p-6">
            <span class="text-zt-xl font-bold"
              >{{$t('message.mfa.backup.heading') }}</span
            >
          </div>
        </template>
        <div class="">
          <div class="flex px-8 py-16">
            <div class="warning-icon mr-10 info-icon flex justify-start items-start">
              <zt-icon name="exclamation-circle-outline" />
            </div>
            <div class="items-center mr-12">
              <template  v-if="showMessageBackup">
                <p class="text-zt-lg text-justify">
                  {{ textErrorBackup }}
                </p>
              </template>
              <template v-else>
                <h2 class="pb-3 text-zt-xl font-normal">
                  {{$t('message.mfa.backup.title') }}
                </h2>
                <p class="text-zt-lg text-justify">
                  {{$t('message.mfa.backup.content') }}
                </p>
              </template>
            </div>
          </div>
        </div>
        <template slot="modal-footer">
          <div
            class="
              zt-modal-footer
              flex
              justify-end
              lg:justify-end
              items-center
              p-4
            "
            style="background-color: #eeeeee"
          >
            <button class="mr-6 text-gray-700" @click="backupDownloadClose()" data-vs-button="backup-download">
              {{$t('message.generalSettings.mfa_active_modal_cancel') }}
            </button>
            <zt-button :disabled="isBackupDownloadDisable" :loader="isLoader" class="ml-1" v-on:click="backupDownload()" data-vs-button="backup-download-disable">
              {{$t('message.generalSettings.mfa_active_modal_solicitar') }}
            </zt-button
            >
          </div>
        </template>
      </zt-modal>

      <zt-modal :z-index="1001" max-width="700px" :active="activeModalSuccess" @close="backupSuccessClose()">
        <template #modal-header>
          <div class="p-6">
            <span class="text-zt-xl font-bold"
              >{{$t('message.mfa.backup.heading') }}</span
            >
          </div>
        </template>
        <div class="">
          <div class="px-8 py-16">
            <h2 class="pb-3 text-zt-xl font-normal"> {{$t('message.mfa.backup.heading_success')}} </h2>
            <p class="text-zt-lg text-justify"> {{$t('message.mfa.backup.content_success')}} </p>
          </div>
        </div>
      </zt-modal>

      <zt-modal :z-index="1001" max-width="700px" :active="emptyDonwloadObservations" @close="emptyDonwloadObservationsClose()">
        <template #modal-header>
          <div class="p-6">
            <span class="text-zt-xl font-bold"
              >{{$t('message.documentSearch.donwload.observations') }}</span
            >
          </div>
        </template>
        <div class="">
          <div class="px-8 py-16">
            <p class="text-zt-lg text-justify"> {{$t('message.documentSearch.donwload.popup.observations.empty')}} </p>
          </div>
        </div>
      </zt-modal>
    </div>
  </div>
</template>

<script>
import Search from '@/apiClient/Search'
import { filter, includes, clone } from 'lodash'
import {mapGetters} from "vuex";

const MANPOWER_COMPANY_ID = 135

export default {
  name: 'SearchTableHeader',
  props: ['downloadSelected', 'documentSelected', 'loader'],
  inject: ['store', 'setOrderBy', 'setOrderType', 'emptyDocumentSelected'],
  data() {
    return {
      searchConfig: new Search(),
      active: false,
      activeModalBackup: false,
      defaultItem: {
        id: 'id',
        name: this.$t('message.searchComponent.items.creationDate'),
      },
      loaderList: false,
      loadersArr: [],
      downloadActionId: 29,
      isActionBackup: 107,
      isActionMFA: 86,
      isLoader: false,
      showMessageBackup: false,
      textErrorBackup: '',
      isBackupDownloadDisable: false,
      activeModalMassiveCancel: false,
      isLoaderMassiveCancel: false,
      showMessageMassiveCancel: '',
      massiveCancel: 108,
      activeModalSuccess: false,
      emptyDonwloadObservations: false
    }
  },
  methods: {
    async downloadExcel() {
      this.loaderList = true

      const { filters, orderBy, orderType } = this.store

      const params = `orderBy=${orderBy}&orderType=${orderType}`

      const { data } = await this.searchConfig.DownloadExcel(filters, params)
      
      this.donwloadAsExcel(data, 'Documents')
    },
    async downloadExcelObservations() {
      this.loaderList = true

      const { filters, orderBy, orderType } = this.store

      const params = `orderBy=${orderBy}&orderType=${orderType}`

      const response = this.searchConfig.DownloadExcelObservations(filters, params)
      response
      .then(result => {
        console.log(result)
        this.donwloadAsExcel(result.data, 'DocumentsObservations')
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.loaderList = false
        }
        this.emptyDonwloadObservations = true
      })
    },
    async downloadMetadata(id) {
      this.loadersArr.push(id)

      const { filters} = clone(this.store);
      filters.eformExport = [id];
      delete filters.eform;

      const { data } = await this.searchConfig.DownloadMetadata(filters)

      this.donwloadAsExcel(data, id)
    },
    donwloadAsExcel(data, filename){
      const newBlob = new Blob([data], { type: 'application/vnd.ms-excel' })
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }
      const urlFile = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = urlFile
      link.download = `${filename}.xls`
      link.click()
      this.loaderList = false
      setTimeout(function() {
        window.URL.revokeObjectURL(urlFile)
      }, 100)
    },
    setSortOption(event) {
      if (this.sortSelected === event.value) {
        return this.setOrderBy('id')
      }
      this.setOrderBy(event.value)
    },
    setOrderTypeSelected() {
      const { orderType } = this.store

      const newOrderType = orderType === 'desc' ? 'asc' : 'desc'

      this.setOrderType(newOrderType)
    },
    validationMFA(){
      if(this.isActionAllowed(this.isActionMFA)){
        this.activeModalBackup = !this.activeModalBackup
      } else {
        this.$emit('show-info-mfa', true);
      }
    },
    async backupDownload() {
      if (this.isBackupDownloadDisable) return
      this.isLoader = true
      try {
        const res = await this.searchConfig.BackupDocuments()
        if (res.status === 201) {
          this.isLoader = false
          this.activeModalBackup = false
          this.activeModalSuccess = true
        }
      } catch (e) {
        this.isLoader = false
        this.isBackupDownloadDisable = true
        if (e.response.status === 400) {
          this.showMessageBackup = true
          this.textErrorBackup = e.response.data.results.data[0]
        }
      }
    },
    backupDownloadClose(){
      this.activeModalBackup = false
      this.showMessageBackup = false
      this.textErrorBackup = ''
      this.isBackupDownloadDisable = false
    },
    backupSuccessClose(){
      this.activeModalSuccess = false
    },
    emptyDonwloadObservationsClose(){
      this.emptyDonwloadObservations = false
    },
    getModalMassiveCancel(){
      this.activeModalMassiveCancel = !this.activeModalMassiveCancel
    },
    massiveCancelModalClose(){
      this.activeModalMassiveCancel = false
    },
    async getMassiveCancel(){
      this.isLoaderMassiveCancel = true
      try {
        const ids = this.documentSelected.map((id) => parseInt(id))
        const res = await this.searchConfig.DocumentMassiveCancel(ids)
        if (res.status === 200) {
          this.isLoaderMassiveCancel = false
          this.activeModalMassiveCancel = false
          this.emptyDocumentSelected()
          this.$emit('cancelled-documents', {
            code: 'MASSIVE_CANCEL_SUCCESS',
            status: 'info'
          })
        }
      } catch (e) {
        this.isLoaderMassiveCancel = false
        this.activeModalMassiveCancel = false
        if (e.response.status === 400) {
          this.showMessageMassiveCancel = false
          this.$emit('cancelled-documents', {
            code: e.response.data.codes[0].code,
            status: 'danger'
          })
        } else {
          this.$emit('cancelled-documents', {
            code: 'GENERIC',
            status: 'danger'
          })
        }
      }
    }
  },
  computed: {
    sortOpts() {
      const baseOptions = [
        {
          value: 'employee',
          text: this.$t('message.searchComponent.items.name'),
        },
        {
          value: 'fiscalId',
          text: this.$t('message.userActive.cuil'),
        },
        {
          value: 'signStatus',
          text: this.$t('message.searchComponent.items.status'),
        },
        {
          value: 'id',
          name: this.$t('message.searchComponent.items.creationDate'),
        },
        {
          value: 'location',
          text: this.$t('message.searchComponent.items.location'),
        },
        {
          value: 'period',
          text: this.$t('message.searchComponent.items.period'),
        },
        {
          value: 'sector',
          text: this.$t('message.searchComponent.items.sector'),
        },
        {
          value: 'name',
          text: this.$t('message.searchComponent.items.docType'),
        }
      ]

      const manpowerOptions = [
        {
          value: 'company',
          text: this.$t('message.searchComponent.items.company'),
        },
        {
          value: 'branch',
          text: this.$t('message.searchComponent.items.branch'),
        },
        {
          value: 'client',
          text: this.$t('message.searchComponent.items.client_cuit'),
        }
      ]

      return this.isManPower 
        ? [...baseOptions, ...manpowerOptions]
        : baseOptions
    },
    sortSelected() {
      return this.store.orderBy
    },
    isSortSelected() {
      return (id) =>
        this.sortSelected === id ? 'bg-zt-primary-200 text-white' : ''
    },
    labelSortOptions() {
      if (this.sortSelected !== 'id') {
        const option = filter(
          this.sortOpts,
          (opt) => opt.value === this.sortSelected
        )

        return option[0].text
      }

      return this.$t('message.searchComponent.items.creationDate')
    },
    orderTypeIcon() {
      return this.store.orderType === 'desc' ? 'arrow-down' : 'arrow-up'
    },
    isLoadingActive() {
      return (id) => includes(this.loadersArr, id)
    },
    isManPower() {
      return this.$store.state.user.empresa.id === MANPOWER_COMPANY_ID
    },
    ...mapGetters(['isActionAllowed']),
  }
}
</script>
<style scoped lang="scss">
.list--container {
  max-height: 500px;
  overflow-y: auto;
}

.list--item {
  border-top: 0.5px solid #b5b5b5;
  border-bottom: 0.5px solid #b5b5b5;
}

.loader--container {
  height: 20px;
  width: 20px;
}

.custom-width {
  width: 53%;
}

::v-deep {
  .zt-dropdown {
    border: none;
    color: #969696;
  }
  .zt-dropdown-item__content{
    font-family: Roboto;
    color: #5d5b5b;
  }
} 

::v-deep .zt-dropdown-outlined .zt-dropdown-input {
  font-weight: 500;
}
.info-icon {
  font-size: 5rem ;
  color: #fb8c00;
}
.info-box{
  padding: 1em;
  margin-bottom: 1em;
  background: #ffc;
}
</style>
